import { For, Show } from 'solid-js';
import { A, useLocation } from '@solidjs/router';
import Text from './Text';
import { useFeatureFlag } from '../hooks/useFeatureFlag';
import styles from './PageTabs.module.css';

export interface PageTab {
    href: string;
    icon: string;
    label: string;
    exact: boolean;
    flag: string | null;
}

export default function PageTabs(props: { tabs: readonly PageTab[] }) {
    const location = useLocation();

    const isActive = (href: string, exact: boolean) =>
        exact ? location.pathname === href : location.pathname.startsWith(href);

    const isVisible = (flag: string | null) => flag === null || useFeatureFlag(flag)();

    return (
        <div class={styles.tabs}>
            <For each={props.tabs}>
                {(tab) => (
                    <Show when={isVisible(tab.flag)}>
                        <A href={tab.href} class={`${styles.tab} ${isActive(tab.href, tab.exact) ? styles.tabActive : ''}`}>
                            <i class={`fa-solid ${tab.icon}`} />
                            <Text val={tab.label} />
                        </A>
                    </Show>
                )}
            </For>
        </div>
    );
}
